<div [innerHtml]="diffHtml">
</div>
